__turbopack_context__.v({
  "addSubtitle": "BigHeroBanner-module-scss-module__qaCLDq__addSubtitle",
  "addTitle": "BigHeroBanner-module-scss-module__qaCLDq__addTitle",
  "footerItem": "BigHeroBanner-module-scss-module__qaCLDq__footerItem",
  "footerList": "BigHeroBanner-module-scss-module__qaCLDq__footerList",
  "header": "BigHeroBanner-module-scss-module__qaCLDq__header",
  "img": "BigHeroBanner-module-scss-module__qaCLDq__img",
  "main": "BigHeroBanner-module-scss-module__qaCLDq__main",
  "subtitle": "BigHeroBanner-module-scss-module__qaCLDq__subtitle",
  "textWrapper": "BigHeroBanner-module-scss-module__qaCLDq__textWrapper",
  "title": "BigHeroBanner-module-scss-module__qaCLDq__title",
});
